import {
  LoginFlow,
  RecoveryFlow,
  RegistrationFlow,
  SettingsFlow,
  VerificationFlow,
} from "@ory/client";
import { Trans } from "react-i18next";

import { uiTextFormattedContext, uiTextFormattedMessage } from "~/libs/ory/helpers";
import { Alert } from "~/ui/components";

type Props = {
  flow?:
    | LoginFlow
    | RecoveryFlow
    | RegistrationFlow
    | SettingsFlow
    | VerificationFlow;
};

const FlowMessage = ({ flow }: Props) => {
  const flowMessages = flow?.ui?.messages || [];

  if (!flowMessages.length) return <></>;

  const message = flowMessages[flowMessages.length - 1];
  const context = uiTextFormattedContext(message);

    return (
      <Alert text="">
        <Trans
          i18nKey={`identities.messages.${message.id}`}
          values={uiTextFormattedContext(message)}
          components={{
            ...(context?.newLoginUrl && {
              newLoginUrl: <a href={context.newLoginUrl} />,
            }),
          }}
        />
      </Alert>
    );
};

export { FlowMessage };
